export default __webpack_public_path__ + "static/media/inspire_web-lg@1x.325b51d7.jpg";